module.exports = __webpack_public_path__ + "static/aon-categories--mobile-fe735a1ce881867d430d812537ffdc30.png";